import { Component, Input, Output, EventEmitter } from 'ng-metadata/core';
import './menu-trigger-icon-button.component.scss';

/**
 * @ngdoc directive
 * @name mwMenuTriggerIconButton
 * @module mw.components.menu
 *
 * @param {string} [aria-label] - The aria-label that should be applied to the menu trigger button.
 * @param {string} [btn-class] - Add additional class to the button if you need to override/customize the button styles.
 * @param {string} [icon] - Name of an icon to be added to the button.  Should be in the same format supported by the 'md-svg-icon' param of an `<md-icon>`.
 * @param {expression} [on-click] - Angular expression to evaluate on click of the button.
 * @param {string} [tooltip] - The text that should be displayed as tooltip on hover of the button.
 * @param {string} [tooltip-direction] - The direction that the tooltip is shown, relative to the parent element. Supports top, right, bottom, and left. Defaults to bottom.
 *
 * @description
 * `<mw-menu-trigger-icon-button>` is an icon button component that can be used inside an `<md-menu>` to trigger opening the menu.
 *
 * @usage
 * <hljs hljs-language="html">
 *
 *   <mw-menu-trigger-icon-button icon="content:ic_sort_24px" tooltip="{{'Sort' | translate}}" on-click="$mdOpenMenu($event)"></mw-menu-trigger-icon-button>
 *
 * </hljs>
 *
 */
@Component({
    selector: 'mw-menu-trigger-icon-button',
    template: `
        <mw-icon-button
            tabindex="-1"
            class="mw-menu-trigger-icon-button md-icon-button {{::$ctrl.btnClass || ''}}"
                svg-icon="{{::$ctrl.icon}}"
            aria-label="{{::$ctrl.tooltip}}"
            tooltip="{{::$ctrl.tooltip}}"
            tooltipDirection="{{::$ctrl.tooltipDirection}}"
            ng-click="::$ctrl.handleClick($event)"
            hover="true">
        </mw-icon-button>
      `
})
export class MenuTriggerIconButtonComponent {
    @Input('@') ariaLabel: string;
    @Input('@') btnClass: string;
    @Input('@') icon: string;
    @Input('@') tooltip: string;
    @Input('@') tooltipDirection: string;
    @Output() onClick = new EventEmitter<ng.IAngularEvent>();

    constructor() {
        'ngInject';
    }

    handleClick(event: ng.IAngularEvent) {
        this.onClick.emit(event);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/menu/menu-trigger/menu-trigger-icon-button.component.ts